/* StickerFactory - Forma de entrega (DAC), pre-checkout step on the cart page.
 *
 * What it does:
 *   1. Customer picks "Envío a domicilio" or "Retiro en agencia DAC".
 *   2. For agency pickup: nombre, apellido, celular, departamento -> sucursal
 *      (address + hours shown for the chosen one).
 *   3. The choice is written to CART ATTRIBUTES via /cart/update.js, so it
 *      travels into the order and into the panel.
 *   4. The checkout button stays blocked until the choice is complete, because
 *      an order without an agency cannot be produced or shipped.
 *
 * The agency dataset (23 KB) is fetched lazily, only when the customer actually
 * picks agency pickup. Most of the traffic is mobile, so it never pays for data
 * it does not use.
 */
(function () {
  if (customElements.get('sticker-envio-dac')) return;

  var ATTR = {
    metodo: 'Entrega',
    nombre: 'Nombre',
    apellido: 'Apellido',
    celular: 'Celular',
    departamento: 'Departamento',
    sucursal: 'Agencia',
    direccion: 'Direccion de la agencia',
    horarios: 'Horarios de la agencia',
    oficina: 'ID agencia DAC',
    mapa: 'Mapa de la agencia',
    punto: 'Punto de retiro'
  };

  // Every agency field, i.e. everything that must be wiped when the customer is
  // not picking up at a DAC branch.
  var AGENCY_ATTRS = [
    ATTR.departamento, ATTR.sucursal, ATTR.direccion,
    ATTR.horarios, ATTR.oficina, ATTR.mapa
  ];

  // Methods that collect a name and a phone: both of them need the "pedido
  // pronto" message to reach the customer.
  var CONTACT_METHODS = ['agencia', 'pickup'];
  // Cliente 2026-09-30: los metodos que se ENVIAN (llevan monto minimo). El retiro en local no.
  var SHIP_METHODS = ['domicilio', 'agencia'];

  // The labels are client-editable, and the chosen method is stored on the cart
  // as the LABEL. So a rename in the theme editor would orphan every open cart.
  // These are the labels shipped so far; restore() falls back to them.
  // Last-resort label per method. The theme-editor fields can be blanked, and an
  // order whose Entrega is empty cannot be shipped, so never save an empty one.
  var DEFAULT_LABELS = {
    domicilio: 'Envío a domicilio (Agencia DAC)',
    agencia: 'Retiro en agencia DAC',
    pickup: 'Retiro en Pickup'
  };

  var LEGACY_LABELS = {
    'envío a domicilio': 'domicilio',
    'envio a domicilio': 'domicilio',
    'envío a domicilio (agencia dac)': 'domicilio',
    'envio a domicilio (agencia dac)': 'domicilio',
    'retiro en agencia dac': 'agencia',
    'retiro en pickup': 'pickup'
  };

  var HDAYS = ['Lun a Vie', 'Sáb', 'Dom'];

  // Two DAC records carry unparsed hours with raw <br /> in them. Rendering
  // those verbatim puts literal markup in front of the customer and onto the
  // order, so flatten them into one readable line.
  function tidyHours(raw) {
    return String(raw || '')
      .replace(/<br\s*\/?>/gi, ' / ')
      .replace(/\s*\/\s*/g, ' / ')
      .replace(/\s+/g, ' ')
      .replace(/^\s*\/\s*|\s*\/\s*$/g, '')
      .trim();
  }

  // UY mobile: 9 digits starting with 09, optionally written with +598 / 598.
  function normalizePhone(raw) {
    var d = String(raw || '').replace(/\D+/g, '');
    if (d.indexOf('598') === 0) d = d.slice(3);
    if (d.length === 8 && d.charAt(0) === '9') d = '0' + d;
    return d;
  }
  function phoneValid(raw) {
    var d = normalizePhone(raw);
    return /^09\d{7}$/.test(d);
  }
  function prettyPhone(raw) {
    var d = normalizePhone(raw);
    return /^09\d{7}$/.test(d) ? d.slice(0, 3) + ' ' + d.slice(3, 6) + ' ' + d.slice(6) : String(raw || '').trim();
  }

  customElements.define('sticker-envio-dac', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      var cfgEl = this.querySelector('.sed-config');
      if (!cfgEl) {
        // Upgraded before children parsed. Retry on the next tick.
        if (this.isConnected && (this._tries = (this._tries || 0) + 1) < 50) {
          setTimeout(this.connectedCallback.bind(this), 0);
        }
        return;
      }
      try {
        this.cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.error('[sed] invalid config JSON', e);
        return;
      }
      this._init = true;

      this.data = null;
      this.saveTimer = null;
      this.lastSent = null;
      this.state = {
        metodo: '',
        nombre: '',
        apellido: '',
        celular: '',
        departamento: '',
        sucursal: '',
        rec: null
      };

      this.els = {
        methods: Array.prototype.slice.call(this.querySelectorAll('.sed-method')),
        panels: Array.prototype.slice.call(this.querySelectorAll('.sed-panel')),
        dep: this.querySelector('[data-f="departamento"]'),
        suc: this.querySelector('[data-f="sucursal"]'),
        sucField: this.querySelector('[data-suc]'),
        card: this.querySelector('[data-card]'),
        error: this.querySelector('[data-error]'),
        // data-only takes a comma list of methods, e.g. data-only="agencia,pickup".
        onlyNodes: Array.prototype.slice.call(this.querySelectorAll('[data-only]'))
      };

      // Per-method rows (reference prices, pickup deadline, contact fields) must
      // not show before a method is chosen. restore()/setMethod() take over.
      this.els.onlyNodes.forEach(function (n) { n.hidden = true; });

      // Order matters. watchCartFooter() records which checkout buttons the THEME
      // disabled (empty cart) so we never re-enable those. It has to run before
      // restore(), because restore() can lock the button itself on a partially
      // saved cart, and that lock would otherwise be mistaken for the theme's.
      this.watchCartFooter();
      this.bind();
      this.restore();
      this.gate();
    }

    /* ---------------- wiring ---------------- */

    bind() {
      var self = this;

      this.els.methods.forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.setMethod(btn.dataset.method);
        });
      });

      ['nombre', 'apellido', 'celular'].forEach(function (f) {
        var el = self.querySelector('[data-f="' + f + '"]');
        if (!el) return;
        el.addEventListener('input', function () {
          self.state[f] = el.value;
          el.classList.remove('is-bad');
          self.queueSave();
          self.gate();
        });
        el.addEventListener('blur', function () {
          if (f === 'celular' && el.value.trim()) {
            el.classList.toggle('is-bad', !phoneValid(el.value));
          }
        });
      });

      if (this.els.dep) {
        this.els.dep.addEventListener('change', function () {
          self.state.departamento = self.els.dep.value;
          self.state.sucursal = '';
          self.state.rec = null;
          self.fillSucursales();
          self.renderCard();
          self.queueSave();
          self.gate();
        });
      }

      if (this.els.suc) {
        this.els.suc.addEventListener('change', function () {
          self.state.sucursal = self.els.suc.value;
          self.state.rec = self.findRec(self.state.departamento, self.state.sucursal);
          self.renderCard();
          self.queueSave();
          self.gate();
        });
      }
    }

    /* ---------------- state ---------------- */

    setMethod(m) {
      var self = this;
      this.state.metodo = m;

      this.els.methods.forEach(function (b) {
        var on = b.dataset.method === m;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.els.panels.forEach(function (p) {
        p.hidden = p.dataset.panel !== m;
      });
      this.els.onlyNodes.forEach(function (n) {
        n.hidden = String(n.dataset.only || '')
          .split(',')
          .map(function (x) { return x.trim(); })
          .indexOf(m) === -1;
      });

      if (m === 'agencia') {
        this.loadData().then(function () {
          self.fillDepartamentos();
          if (self.state.departamento) {
            self.els.dep.value = self.state.departamento;
            self.fillSucursales();
            if (self.state.sucursal) {
              self.els.suc.value = self.state.sucursal;
              self.state.rec = self.findRec(self.state.departamento, self.state.sucursal);
              self.renderCard();
            }
          }
          self.gate();
        }).catch(function (e) {
          console.error('[sed] agency data failed to load', e);
          self.showError('No pudimos cargar la lista de agencias. Recargá la página e intentá de nuevo.');
        });
      } else {
        // Home delivery: drop any agency data so a stale agency never rides along.
        this.state.departamento = '';
        this.state.sucursal = '';
        this.state.rec = null;
        if (this.els.dep) this.els.dep.value = '';
        if (this.els.suc) this.els.suc.value = '';
        if (this.els.sucField) this.els.sucField.hidden = true;
        this.renderCard();
      }

      this.clearError();
      this.queueSave();
      this.gate();
      // Aviso de monto minimo apenas elige un envio por debajo del minimo (no espera al checkout).
      if (this.belowShippingMin()) this.showError(this.minMsg());
    }

    restore() {
      var s = this.cfg.saved || {};
      var L = this.cfg.labels || {};
      var self = this;

      ['nombre', 'apellido', 'celular'].forEach(function (f) {
        if (!s[f]) return;
        self.state[f] = s[f];
        var el = self.querySelector('[data-f="' + f + '"]');
        if (el) el.value = s[f];
      });
      this.state.departamento = s.departamento || '';
      this.state.sucursal = s.sucursal || '';

      var m = this.methodFromSaved(s, L);
      if (m) this.setMethod(m);
    }

    /* The cart stores the visible LABEL, not the internal key, and every label is
     * editable in the theme editor. Matching on the current label alone means any
     * rename silently orphans every open cart: the choice vanishes and checkout
     * re-locks with no explanation. So resolve in three passes, cheapest first.
     * Returning '' is the safe failure: the customer just picks again. */
    methodFromSaved(s, L) {
      var v = String(s.metodo || '').trim();
      if (!v) return '';

      var keys = Object.keys(L || {});
      for (var i = 0; i < keys.length; i++) {
        if (v === String(L[keys[i]]).trim()) return keys[i];
      }

      // The saved data outranks a stale label: an agency can only have been
      // saved by the agency flow.
      if (s.sucursal) return 'agencia';

      return LEGACY_LABELS[v.toLowerCase()] || '';
    }

    /* ---------------- data ---------------- */

    loadData() {
      var self = this;
      if (this.data) return Promise.resolve(this.data);
      if (this._loading) return this._loading;

      this._loading = new Promise(function (resolve, reject) {
        if (window.STICKER_DAC_AGENCIAS) {
          self.data = self.applyOverrides(window.STICKER_DAC_AGENCIAS);
          return resolve(self.data);
        }
        var s = document.createElement('script');
        s.src = self.cfg.dataUrl;
        s.onload = function () {
          if (!window.STICKER_DAC_AGENCIAS) return reject(new Error('dataset missing'));
          self.data = self.applyOverrides(window.STICKER_DAC_AGENCIAS);
          resolve(self.data);
        };
        s.onerror = function () { reject(new Error('script error')); };
        document.head.appendChild(s);
      });
      return this._loading;
    }

    /* DAC opens and closes branches and publishes no feed we can read, so the
     * generated 131-branch list is a baseline the client can correct himself.
     * One instruction per line in the theme editor:
     *     Departamento | Sucursal | Direccion | Horario     (add or replace)
     *     - Departamento | Sucursal                          (remove)
     * A malformed line is skipped rather than throwing, because a typo here must
     * never take the whole agency selector down. */
    applyOverrides(base) {
      var raw = String((this.cfg && this.cfg.agenciasOverride) || '').trim();
      if (!raw) return base;

      // Shallow-copy per departamento so we never mutate the shared global.
      var data = {};
      Object.keys(base).forEach(function (k) { data[k] = base[k].slice(); });

      raw.split(/\r?\n/).forEach(function (line) {
        var t = line.trim();
        if (!t || t.charAt(0) === '#') return;

        var remove = t.charAt(0) === '-';
        if (remove) t = t.slice(1).trim();

        var parts = t.split('|').map(function (x) { return x.trim(); });
        var dep = parts[0];
        var name = parts[1];
        if (!dep || !name) return;

        var list = data[dep];
        var at = -1;
        if (list) {
          for (var i = 0; i < list.length; i++) {
            if (list[i].n.toLowerCase() === name.toLowerCase()) { at = i; break; }
          }
        }

        if (remove) {
          if (at !== -1) list.splice(at, 1);
          if (list && !list.length) delete data[dep];
          return;
        }

        var rec = { n: name, id: '', d: parts[2] || '', m: '', h: null, r: parts[3] || '' };
        if (at !== -1) {
          // Keep the DAC office id and map link of the branch being corrected.
          rec.id = list[at].id || '';
          rec.m = list[at].m || '';
          list[at] = rec;
        } else {
          if (!data[dep]) data[dep] = [];
          data[dep].push(rec);
        }
      });

      return data;
    }

    findRec(dep, name) {
      var list = (this.data && this.data[dep]) || [];
      for (var i = 0; i < list.length; i++) if (list[i].n === name) return list[i];
      return null;
    }

    fillDepartamentos() {
      if (!this.els.dep || this.els.dep.dataset.filled) return;
      var keys = Object.keys(this.data).sort(function (a, b) {
        return a.localeCompare(b, 'es');
      });
      var frag = document.createDocumentFragment();
      keys.forEach(function (k) {
        var o = document.createElement('option');
        o.value = k;
        o.textContent = k;
        frag.appendChild(o);
      });
      this.els.dep.appendChild(frag);
      this.els.dep.dataset.filled = '1';
    }

    fillSucursales() {
      var sel = this.els.suc;
      if (!sel) return;
      var dep = this.state.departamento;
      var list = (this.data && this.data[dep]) || [];

      sel.innerHTML = '';
      var first = document.createElement('option');
      first.value = '';
      first.textContent = list.length ? 'Elegí la agencia (' + list.length + ')' : 'Sin agencias';
      sel.appendChild(first);

      list.slice().sort(function (a, b) {
        return a.n.localeCompare(b.n, 'es');
      }).forEach(function (r) {
        var o = document.createElement('option');
        o.value = r.n;
        o.textContent = r.n;
        sel.appendChild(o);
      });

      this.els.sucField.hidden = !dep;
      sel.value = '';
    }

    renderCard() {
      var card = this.els.card;
      if (!card) return;
      var r = this.state.rec;
      if (!r) {
        card.hidden = true;
        card.innerHTML = '';
        return;
      }

      var rows = '';
      if (r.h) {
        var days = ['Lunes a viernes', 'Sábados', 'Domingos'];
        for (var i = 0; i < 3; i++) {
          if (!r.h[i]) continue;
          rows += '<li><span>' + days[i] + '</span><strong>' + this.esc(r.h[i]) + '</strong></li>';
        }
      } else if (r.r) {
        rows = '<li class="sed-card-raw">' + this.esc(tidyHours(r.r)) + '</li>';
      }

      card.innerHTML =
        '<p class="sed-card-name">' + this.esc(r.n) + '</p>' +
        '<p class="sed-card-addr">' + this.esc(r.d) + '</p>' +
        (rows ? '<ul class="sed-card-hours">' + rows + '</ul>' : '') +
        (r.m ? '<a class="sed-card-map" href="' + this.esc(r.m) + '" target="_blank" rel="noopener">Ver en el mapa</a>' : '');
      card.hidden = false;
    }

    esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* ---------------- persistence ---------------- */

    payload() {
      var L = this.cfg.labels || {};
      var s = this.state;
      var m = s.metodo;
      var out = {};
      out[ATTR.metodo] = m ? (String(L[m] || '').trim() || DEFAULT_LABELS[m] || '') : '';

      // Empty string clears a cart attribute, so start from a clean slate and
      // only fill what this method actually owns. That way a stale agency can
      // never ride along after the customer switches.
      out[ATTR.punto] = '';
      AGENCY_ATTRS.forEach(function (k) { out[k] = ''; });

      var wantsContact = CONTACT_METHODS.indexOf(m) !== -1;
      out[ATTR.nombre] = wantsContact ? s.nombre.trim() : '';
      out[ATTR.apellido] = wantsContact ? s.apellido.trim() : '';
      out[ATTR.celular] = wantsContact ? prettyPhone(s.celular) : '';

      if (m === 'agencia') {
        var r = s.rec;
        out[ATTR.departamento] = s.departamento;
        out[ATTR.sucursal] = s.sucursal;
        out[ATTR.direccion] = r ? r.d : '';
        // Label the days. Unlabelled "10:00-18:00 / 9:00-13:00 / Cerrado" on an
        // order is guesswork for whoever reads it in the panel.
        out[ATTR.horarios] = r ? (r.h ? HDAYS.map(function (d, i) {
          return r.h[i] ? d + ' ' + r.h[i] : '';
        }).filter(Boolean).join(' / ') : tidyHours(r.r)) : '';
        out[ATTR.oficina] = r ? r.id : '';
        out[ATTR.mapa] = r ? r.m : '';
      } else if (m === 'pickup') {
        // Record WHERE they collect. The address is editable, and it will change
        // when Sticker Factory opens its own pickup point, so the order has to
        // carry the address that was shown at the time of purchase.
        var p = this.cfg.pickup || {};
        out[ATTR.punto] = [p.nombre, p.direccion, p.horarios]
          .map(function (x) { return String(x || '').trim(); })
          .filter(Boolean)
          .join(' - ');
      }
      return out;
    }

    queueSave() {
      var self = this;
      clearTimeout(this.saveTimer);
      this.saveTimer = setTimeout(function () { self.save(); }, 450);
    }

    save() {
      var body = this.payload();
      var sig = JSON.stringify(body);
      if (sig === this.lastSent) return Promise.resolve();
      this.lastSent = sig;

      return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/update.js'
        : '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: body })
      }).catch(function (e) {
        console.error('[sed] could not save delivery choice', e);
      });
    }

    /* ---------------- checkout gate ---------------- */

    // Cliente 2026-09-30: true si el metodo elegido se ENVIA (domicilio/agencia) y el carrito no
    // llega al monto minimo. Regla de negocio, se evalua aunque `require` este off. 0 = sin minimo.
    belowShippingMin() {
      var min = +(this.cfg.envioMinimo || 0);
      if (!(min > 0)) return false;
      if (SHIP_METHODS.indexOf(this.state.metodo) === -1) return false;
      return (+(this.cfg.cartTotal || 0)) < min;
    }
    minMsg() {
      var min = +(this.cfg.envioMinimo || 0);
      var tpl = this.cfg.envioMinimoMsg || 'Los envíos son a partir de {min}.';
      return tpl.split('{min}').join('$' + min);
    }
    missing() {
      var s = this.state;
      var out = [];
      // Monto minimo de envio: bloquea aunque `require` este off, porque es regla del negocio.
      if (this.belowShippingMin()) out.push('envio_minimo');
      if (!this.cfg.require) return out;
      if (!s.metodo) return out.concat(['metodo']);
      // Envio a domicilio junta el resto en el checkout; agencia y pickup necesitan los datos de contacto.
      if (CONTACT_METHODS.indexOf(s.metodo) !== -1) {
        if (!s.nombre.trim()) out.push('nombre');
        if (!s.apellido.trim()) out.push('apellido');
        if (!phoneValid(s.celular)) out.push('celular');
        if (s.metodo === 'agencia') {
          if (!s.departamento) out.push('departamento');
          if (!s.sucursal) out.push('sucursal');
        }
      }
      return out;
    }

    checkoutTargets() {
      return Array.prototype.slice.call(
        document.querySelectorAll('[name="checkout"], .cart__dynamic-checkout-buttons')
      );
    }

    gate() {
      var self = this;
      var blocked = this.missing().length > 0;

      this.checkoutTargets().forEach(function (el) {
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
          // Never re-enable a button the theme disabled because the cart is empty.
          if (el.dataset.sedEmpty === '1') return;
          if (blocked) {
            if (!el.disabled) el.dataset.sedTouched = '1';
            el.disabled = true;
          } else if (el.dataset.sedTouched === '1') {
            el.disabled = false;
            delete el.dataset.sedTouched;
          }
        }
        el.classList.toggle('sed-locked', blocked);
      });

      if (!this._clickGuard) {
        this._clickGuard = true;
        document.addEventListener('click', function (ev) {
          var t = ev.target && ev.target.closest ? ev.target.closest('[name="checkout"], .cart__dynamic-checkout-buttons') : null;
          if (!t) return;
          if (self.missing().length === 0) return;
          ev.preventDefault();
          ev.stopPropagation();
          self.flagMissing();
        }, true);
      }
    }

    flagMissing() {
      var miss = this.missing();
      var self = this;
      // Si lo que falta es el monto minimo de envio, ese es el mensaje mas util.
      this.showError(miss.indexOf('envio_minimo') > -1
        ? this.minMsg()
        : (this.cfg.blockMsg || 'Elegí la forma de entrega para continuar.'));

      miss.forEach(function (f) {
        var el = self.querySelector('[data-f="' + f + '"]');
        if (el) el.classList.add('is-bad');
      });
      if (miss.indexOf('metodo') > -1) {
        this.querySelector('.sed-methods').classList.add('is-bad');
        setTimeout(function () {
          var n = self.querySelector('.sed-methods');
          if (n) n.classList.remove('is-bad');
        }, 1600);
      }
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    showError(msg) {
      if (!this.els.error) return;
      this.els.error.textContent = msg;
      this.els.error.hidden = false;
    }

    clearError() {
      if (!this.els.error) return;
      this.els.error.hidden = true;
      this.els.error.textContent = '';
    }

    /* The theme re-renders the cart footer on every quantity change, which
     * replaces the checkout button and wipes our disabled state. Re-apply. */
    watchCartFooter() {
      var self = this;
      var host = document.getElementById('main-cart-footer') || document.querySelector('.cart__footer');
      var root = (host && host.parentNode) || document.body;

      // Remember which buttons the theme itself disabled (empty cart). Never
      // claim one we disabled ourselves, or it can never be unlocked again.
      document.querySelectorAll('[name="checkout"]').forEach(function (b) {
        if (b.disabled && !b.dataset.sedTouched) b.dataset.sedEmpty = '1';
      });

      var mo = new MutationObserver(function () {
        clearTimeout(self._reapply);
        self._reapply = setTimeout(function () {
          document.querySelectorAll('[name="checkout"]').forEach(function (b) {
            if (b.disabled && !b.dataset.sedTouched) b.dataset.sedEmpty = '1';
          });
          self.gate();
        }, 60);
      });
      mo.observe(root, { childList: true, subtree: true });
    }
  });
})();
